<template>
  <el-dialog
    width="90%"
    top="10px"
    title="选择工作记录"
    :visible.sync="dialogVisible"
    @close="close"
    append-to-body
  >
    <index :isSelectStyle="true" @getSelectedResult="getSelectedResult"></index>
  </el-dialog>
</template>

<script>
import index from "./index.vue";
export default {
  components: {
    index
  },
  props: {
    outDialogVisible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    outDialogVisible(newValue) {
      this.dialogVisible = newValue;
    }
  },
  data() {
    return {
      dialogVisible: false
    };
  },

  methods: {
    close() {
      this.$emit("update:outDialogVisible", false);
    },
    getSelectedResult(val) {
      console.log("selectRecord", val);
      this.$emit("getSelectedResult", val);
    }
  }
};
</script>

<style lang="scss" scoped></style>
